export default "__VITE_PUBLIC_ASSET__b475ffd7__"